import script from "./FieldControlEntity.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldControlEntity.vue?vue&type=script&setup=true&lang=ts"

import "./FieldControlEntity.vue?vue&type=style&index=0&id=4549ca18&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4549ca18"]])

export default __exports__